import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["handleNext", "handlePrev"],
    _excluded2 = ["handleGoToSlide"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { forwardRef, useContext } from 'react';
import cx from 'classnames';
import { prefix } from '../../../tools/settings';
import { Styled } from './Controls.styles';
import { CarouselContext } from '../Carousel';
import VisuallyHidden from '../../VisuallyHidden';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var useCarouselContext = function useCarouselContext() {
  return useContext(CarouselContext);
};

var Navigation = forwardRef(function (_ref, ref) {
  var handleNext = _ref.handleNext,
      handlePrev = _ref.handlePrev,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx(_defineProperty({}, "".concat(prefix, "-carousel__navigation"), true));

  var _useCarouselContext = useCarouselContext(),
      hasPaging = _useCarouselContext.hasPaging,
      slideCount = _useCarouselContext.slideCount,
      activeIndex = _useCarouselContext.activeIndex,
      wrapAround = _useCarouselContext.wrapAround;

  var prevIsDisabled = activeIndex === 0 && !wrapAround || slideCount === 0;
  var nextIsDisabled = activeIndex + 1 === slideCount && !wrapAround || slideCount === 0;
  return _jsxs(Styled.Navigation, _objectSpread(_objectSpread({
    ref: ref,
    className: className
  }, rest), {}, {
    children: [_jsx(Styled.PrevButton, {
      hasPaging: hasPaging,
      icon: "chevron-left",
      variant: "secondary",
      isDisabled: prevIsDisabled,
      onClick: function onClick() {
        return handlePrev();
      }
    }), _jsx(Styled.NextButton, {
      hasPaging: hasPaging,
      icon: "chevron-right",
      variant: "secondary",
      isDisabled: nextIsDisabled,
      onClick: function onClick() {
        return handleNext();
      }
    })]
  }));
});
var PagingDots = forwardRef(function (_ref2, ref) {
  var handleGoToSlide = _ref2.handleGoToSlide,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  var pagingDotsClassName = cx(_defineProperty({}, "".concat(prefix, "-carousel__pagingDots"), true));

  var _useCarouselContext2 = useCarouselContext(),
      activeIndex = _useCarouselContext2.activeIndex,
      slideCount = _useCarouselContext2.slideCount;

  var dotIndexes = [];

  for (var i = 0; i < slideCount; i++) {
    dotIndexes.push(i);
  }

  return _jsx(Styled.PagingDots, _objectSpread(_objectSpread({
    ref: ref,
    className: pagingDotsClassName
  }, rest), {}, {
    children: dotIndexes.map(function (index) {
      var _cx3;

      var pagingDotClassName = cx((_cx3 = {}, _defineProperty(_cx3, "".concat(prefix, "-carousel__pagingDot"), true), _defineProperty(_cx3, "".concat(prefix, "-carousel__pagingDot--isActive"), activeIndex === index), _cx3));
      return _jsx(Styled.Dot, {
        className: pagingDotClassName,
        type: "button",
        onClick: function onClick() {
          return handleGoToSlide(index);
        },
        "aria-label": "slide ".concat(index + 1, " bullet"),
        children: _jsx(VisuallyHidden, {
          children: index + 1
        })
      }, index);
    })
  }));
});
export { Navigation, PagingDots };